
export const RELATIVE_URL = 'tenants';
